import { render, staticRenderFns } from "./index.vue?vue&type=template&id=789eff18"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionCategories: require('/opt/build/repo/components/section/Categories.vue').default,SectionBrands: require('/opt/build/repo/components/section/Brands.vue').default})
